document.addEventListener('DOMContentLoaded', () => {
  const mySwiper = new Swiper ('.swiper-container', swiperCondition);

  UWX.MenuNext('.faq-content .faq-list dt', 'active');
  UWX.MoreContentsAll('.more', '.faq-list > *');
});

const swiperCondition = {
  loop: true,
  speed: 5000,
  slidesPerView: 'auto',
  spaceBetween: 60,
  direction: 'horizontal',
  freeMode: true,
  autoplay: {
  delay: 0,
  stopOnLast: false,
  disableOnInteraction: false
  },
  breakpoints: {
    750: {
      spaceBetween: 25
    },
    320: {
      spaceBetween: 20
    }
  }
}
